import { render, staticRenderFns } from "./AllyInputStatusButton.vue?vue&type=template&id=0bb76c6b&scoped=true&"
import script from "./AllyInputStatusButton.vue?vue&type=script&lang=ts&"
export * from "./AllyInputStatusButton.vue?vue&type=script&lang=ts&"
import style0 from "./AllyInputStatusButton.vue?vue&type=style&index=0&id=0bb76c6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb76c6b",
  null
  
)

export default component.exports